import { Theme } from '@8fig/theme';
import makeStyles from '@material-ui/core/styles/makeStyles';

export const useStyles = makeStyles((theme: Theme) => ({
  dots: { marginTop: theme.spacing(3), marginBottom: theme.spacing(1) },
  textBelowDots: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
}));
